export const RightArrowBlueIcon = (props: any) => (
  <svg
    className={props.className}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 91"
  >
    <path fill="#4187F5" d="M52.35,91H0C54,42.5,53.5,42.5,0,0H52.35" />
  </svg>
);
